// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"368":"85f96f3e","686":"8b16877e","720":"a17a9afa","772":"c5d060b8","927":"94cc9ef7"}[chunkId] + ".css";
};